import { render, staticRenderFns } from "./programAreaIcon.vue?vue&type=template&id=d5b811c8&"
import script from "./programAreaIcon.vue?vue&type=script&lang=js&"
export * from "./programAreaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports